export enum BannerIdEnum {
    TESLA_ANNOUNCEMENT_A = 'tesla_announcement_a',
    TESLA_ANNOUNCEMENT_B = 'tesla_announcement_b',
    TESLA_ANNOUNCEMENT_C = 'tesla_announcement_c',
    MONITORING_MONTHLY_REPORT = 'monitoring_monthly_report',
    WELCOME = 'welcome',
    INVALID_CREDENTIALS = 'invalid_credentials',
    BATTERY_INFO = 'battery_info',
    BATTERY_WELCOME = 'battery_welcome'
}
